import {WebsiteBoot} from './app/com/jwebmp/website/WebsiteBoot/WebsiteBoot';
import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';

bootstrapApplication(WebsiteBoot
, appConfig).catch((err) => console.error(err));